import React, { useState, useRef,useEffect } from "react";
import { calculateRowItem, calculateInvoiceSummary } from "../utils/salesInvoiceCalculator";
import {
  Button,
  Box,
  Typography,
  Grid,
  Paper,
  Divider,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  TextField,
  TableFooter,
  Checkbox,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Card,
  CardContent,
  CardActionArea,
  CircularProgress,
  InputAdornment,
  Alert,RadioGroup,Radio
} from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import axios from "axios";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import LayoutUserHeader from '../components/LayoutUserHeader';
import LayoutUserFooter from '../components/LayoutUserFooter';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

const BASE_URL = process.env.REACT_APP_BASE_URL || '';


const AddSaleInvoice = ({ editModeSale = false, initialValues = {}, invoiceId = null }) => {

  const initialRowState = {
    id: 1,
    productId: "",
    hsnOptions: [],
    unitOptions: [],
    hsn: "",
    unit: "",
    qty: "",
    originalRate: "",
    rate: "",
    discount: "0",
    taxableValue: "",
    igstRate: "",
    igstAmount: "",
    otherCharges: "0",
    cessAmount: "0",
    total: "",
  };

  const [rows, setRows] = useState([initialRowState]);

  const [gstSummary, setGstSummary] = useState([]);


  const originalValuesRef = useRef(null);

  const [registrationData, setRegistrationData] = useState(null);
  const [consigneeShippedToSame, setConsigneeShippedToSame] = useState(true);
  const [reverseCharge, setReverseCharge] = useState('No');
 // const [invoiceNo, setInvoiceNo] = useState(editModeSale && initialValues ? initialValues.invoiceNo.slice(-2) : '');
  const [invoiceNo, setInvoiceNo] = useState(editModeSale && initialValues ? initialValues.invoiceNo.slice(-2) : '');
  //const [invoiceDate, setInvoiceDate] = useState(dayjs().startOf('day'));
  const [invoiceDate, setInvoiceDate] = useState(null);
  const [challanNo, setChallanNo] = useState('');
  const [transportationMode, setTransportationMode] = useState('');
  const [vehicleNo, setVehicleNo] = useState('');
  //const [dateOfSupply, setDateOfSupply] = useState(dayjs().startOf('day'));
  const [dateOfSupply, setDateOfSupply] = useState(null);
  const [placeOfSupply, setPlaceOfSupply] = useState('');
  const [transporterID, setTransporterID] = useState('');
  const [transporterName, setTransporterName] = useState('');
  const [lrNumber, setLrNumber] = useState('');
  
  //const [lrDate, setLrDate] = useState(dayjs().startOf('day'));
  const [lrDate, setLrDate] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [states, setStates] = useState([]);
  const [consigneeList, setConsigneeList] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogConsignee, setOpenDialogConsignee] = useState(false);
  const [loadingConsignees, setLoadingConsignees] = useState(false);
  const [otherCharges, setOtherCharges] = useState(0);
  const [cessAmount, setCessAmount] = useState(0);
 const [invoiceType, setInvoiceType] = useState('Tax Invoice');
  const navigate = useNavigate();
  const [prefix, setPrefix] = useState(editModeSale && initialValues ? initialValues.invoiceNo.slice(0, -2) : '');
 
  const today = dayjs();
const currentYear = today.month() >= 3 ? today.year() : today.year() - 1; // Financial year starts in April
const financialYearStart = dayjs(`${currentYear}-04-01`);
const financialYearEnd = dayjs(`${currentYear + 1}-03-31`);
const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

const initialLocalReceiverDataState = {
  firstName: '',
  address: '',
  gst: '',
  stateName: '',
  stateCode: ''
};
const [localReceiverData, setLocalReceiverData] = useState(initialLocalReceiverDataState);

  useEffect(() => {
  if (editModeSale && initialValues) {
    setInvoiceNo(initialValues.invoiceNo || '');
    setPrefix(initialValues.prefix || ''); // if applicable
    setInvoiceDate(initialValues.invoiceDate || dayjs());
    setReverseCharge(initialValues.reverseCharge || 'No');
    setChallanNo(initialValues.challanNo || '');
    setTransportationMode(initialValues.transportationMode || '');
    setVehicleNo(initialValues.vehicleNo || '');
    //setDateOfSupply(initialValues.dateOfSupply || dayjs());
    setDateOfSupply(
  initialValues.dateOfSupply
    ? dayjs(initialValues.dateOfSupply)
    : null
);
    setPlaceOfSupply(initialValues.placeOfSupply || '');
    setTransporterID(initialValues.transporterID || '');
    setTransporterName(initialValues.transporterName || '');
    setLrNumber(initialValues.lrNumber || '');
   // setLrDate(initialValues.lrDate || dayjs());
   setLrDate(
  initialValues.lrDate
    ? dayjs(initialValues.lrDate)
    : null
);
    setIsSameDetails(initialValues.isSameDetails ?? true);
    setLocalReceiverData(initialValues.localReceiverData || {});
    setConsigneeDetails(initialValues.consigneeDetails || {});
    setOtherCharges(initialValues.otherCharges || 0);
    setCessAmount(initialValues.cess || 0);
    setInvoiceType(initialValues.invoiceType);
    setRows(initialValues.rows || []);
    // Force GST recalculation after rows are set
    setTimeout(() => {
      setRows(prevRows =>
        prevRows.map(r =>
          handleRowCalculation(r) // we'll create this pure calculation function
        )
      );
    }, 0);

        originalValuesRef.current = {
        invoiceNo: initialValues.invoiceNo,
        reverseCharge: initialValues.reverseCharge,
        challanNo: initialValues.challanNo,
        transportationMode: initialValues.transportationMode,
        vehicleNo: initialValues.vehicleNo,
        dateOfSupply: initialValues.dateOfSupply,
        placeOfSupply: initialValues.placeOfSupply,
        transporterID: initialValues.transporterID,
        transporterName: initialValues.transporterName,
        lrNumber: initialValues.lrNumber,
        lrDate: initialValues.lrDate,
        rows: initialValues.rows,
      };
    }
  }, [editModeSale, initialValues]);

  const detectAmendments = (original, updated) => {
    const changes = [];
    const compare = (key, val1, val2) => {
      if (val1 !== val2) {
        changes.push({ field: key, oldValue: val1, newValue: val2 });
      }
    };

    const keys = ['invoiceNo','reverseCharge','challanNo','transportationMode','vehicleNo','dateOfSupply','placeOfSupply','transporterID','transporterName','lrNumber','lrDate','otherCharges','cess'];
    keys.forEach(k => compare(k, original[k], updated[k]));

    const oldRows = original.rows || [];
    const newRows = updated.rows || [];

    newRows.forEach((row, i) => {
      const oldRow = oldRows[i];
      if (!oldRow) {
        changes.push({ field: `rows[${i}]`, oldValue: null, newValue: row });
      } else {
        Object.keys(row).forEach(key => {
          if (row[key] !== oldRow[key]) {
            changes.push({ field: `rows[${i}].${key}`, oldValue: oldRow[key], newValue: row[key] });
          }
        });
      }
    });

    if (oldRows.length > newRows.length) {
      for (let i = newRows.length; i < oldRows.length; i++) {
        changes.push({ field: `rows[${i}]`, oldValue: oldRows[i], newValue: null });
      }
    }

    return changes;
  };

  const getStateCodeFromGST = (gstNumber) => {
  if (!gstNumber || gstNumber.length < 2) return null;
  return parseInt(gstNumber.substring(0, 2));
};


 const determineTaxType = (buyerStateCode, sellerGST) => {
  const sellerStateCode = getStateCodeFromGST(sellerGST);
  if (!sellerStateCode || !buyerStateCode) return null;

  return sellerStateCode === buyerStateCode ? 'SGST/CGST' : 'IGST';
};

useEffect(() => {
  if (editModeSale) return;

  const gstNumber = localStorage.getItem("gstNumber");

  if (!gstNumber) return;

  const fetchInvoiceCount = async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.get(
        `${BASE_URL}/SalesInvoice/List`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const allInvoices = response.data?.data || [];

      console.log("All Invoices:", allInvoices);

      // Match same GST invoices
      // const filteredInvoices = allInvoices.filter(
      //   (invoice) =>
      //     invoice?.GSTNumber
      //       ?.toString()
      //       .trim()
      //       .toUpperCase() ===
      //     gstNumber
      //       ?.toString()
      //       .trim()
      //       .toUpperCase()
      // );
const currentFYStart =
  today.month() >= 3 ? today.year() : today.year() - 1;

const currentFYEnd = currentFYStart + 1;

// Filter same GST + same Financial Year
const filteredInvoices = allInvoices.filter((invoice) => {

  const invoiceGST = invoice?.GSTNumber
    ?.toString()
    .trim()
    .toUpperCase();

  const invoiceDate = dayjs(invoice?.InvoiceDate);

  const invoiceFYStart =
    invoiceDate.month() >= 3
      ? invoiceDate.year()
      : invoiceDate.year() - 1;

  const invoiceFYEnd = invoiceFYStart + 1;

  return (
    invoiceGST ===
      gstNumber?.toString().trim().toUpperCase() &&
    invoiceFYStart === currentFYStart &&
    invoiceFYEnd === currentFYEnd
  );
});
      console.log("Filtered Invoices:", filteredInvoices);

      // Next invoice number
      const nextSerial = filteredInvoices.length + 1;

      // Format like 01, 02, 03
      const generatedInvoiceNo = nextSerial
        .toString()
        .padStart(2, "0");

      setInvoiceNo(generatedInvoiceNo);

    } catch (error) {
      console.error("Failed to fetch invoices:", error);
    }
  };

  fetchInvoiceCount();

}, [editModeSale]);

useEffect(() => {
  if (!editModeSale && registrationData?.stateName) {
    setPlaceOfSupply(registrationData.stateName);
  }
}, [registrationData, editModeSale]);

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const token = localStorage.getItem("token");

const res = await axios.get(`${BASE_URL}/State/GetAllStates`, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});
        if (res.data.success) {
          setStates(res.data.data); // Assuming data is an array of states
        } else {
          setStates([]);
        }
      } catch (error) {
        console.error("Failed to fetch states:", error);
        setStates([]);
      }
    };

    fetchStates();
  }, []);

  useEffect(() => {
    const gstNumber = localStorage.getItem("gstNumber");
    if (!gstNumber) return;
    const fetchRegistrationData = async () => {
      try {
        const token = localStorage.getItem("token");

const response = await axios.get(
  `${BASE_URL}/Registration/GetDetailsByGstNumber/${gstNumber}`,
  {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
);
        if (response.data?.data) {
          setRegistrationData(response.data.data);
          console.log(response.data.data);
        }
      } catch (error) {
        console.error("Failed to fetch registration data:", error);
      }
    };
    fetchRegistrationData();
  }, []);

  const gstNumber = registrationData?.gst || 'N/A';
  const panNumber = gstNumber.substring(2, 12);

  const [isSameDetails, setIsSameDetails] = useState(true);


  const initialConsigneeDetailsState = {
    name: "",
    address: "",
    gstin: "",
    state: "",
    stateCode: "",
  };
  const [consigneeDetails, setConsigneeDetails] = useState(initialConsigneeDetailsState);

  const handleEditClick = () => setEditMode(true);

  const handleBlur = () => {
    if (vehicleNo.length >= 4) {
      const prefix = vehicleNo.substring(0, 4);
      const regex = /^[A-Za-z]{2}[0-9]{2}$/;

      if (!regex.test(prefix)) {
        alert('Invalid Vehicle Number format:\n- First 2 characters must be alphabets\n- Next 2 must be digits');
        setVehicleNo(''); // Clear the textbox
      }
    }
  };

const handleSaveClick = () => {
  // You can persist or just save locally
  setEditMode(false);
};

const handleRowCalculation = (row) => {
  return calculateRowItem(row);
};



  const handleClearConsignee = () => {
    setConsigneeDetails({
      name: "",
      address: "",
      gstin: "",
      state: "",
      stateCode: "",
    });
  };

    const [taxType, setTaxType] = useState(''); // or ""
    const [productList, setProductList] = useState([]);

 useEffect(() => {
   const sellerCode = registrationData?.gst ? registrationData.gst.substring(0, 2) : String(registrationData?.stateCode || '').padStart(2, '0');
   
   let destCode = '';
   if (!isSameDetails && consigneeDetails?.stateCode) {
     destCode = String(consigneeDetails.stateCode).padStart(2, '0');
   } else if (!isSameDetails && consigneeDetails?.gstin && consigneeDetails.gstin.length >= 2) {
     destCode = consigneeDetails.gstin.substring(0, 2);
   } else if (localReceiverData?.stateCode) {
     destCode = String(localReceiverData.stateCode).padStart(2, '0');
   } else if (localReceiverData?.gst && localReceiverData.gst.length >= 2) {
     destCode = localReceiverData.gst.substring(0, 2);
   } else if (localReceiverData?.stateName) {
     const matched = states.find(s => s.stateName?.toUpperCase() === localReceiverData.stateName?.toUpperCase());
     if (matched) destCode = String(matched.stateCode).padStart(2, '0');
   } else if (placeOfSupply) {
     const matched = states.find(s => s.stateName?.toUpperCase() === placeOfSupply?.toUpperCase());
     if (matched) destCode = String(matched.stateCode).padStart(2, '0');
   }

   const sellerCodePadded = String(sellerCode || '').padStart(2, '0');
   const destCodePadded = String(destCode || '').padStart(2, '0');
   const computedTaxType = (sellerCodePadded && destCodePadded && sellerCodePadded === destCodePadded) ? 'SGST_CGST' : 'IGST';
   setTaxType(computedTaxType);

   setRows(prevRows =>
     prevRows.map(row => {
       if (!row.productId) return { ...row, taxType: computedTaxType };

       const qty = parseFloat(row.qty) || 0;
       const rate = parseFloat(row.rate) || 0;
       const discount = parseFloat(row.discount) || 0;
       const discountQty = parseFloat(row.discountQty) || 0;
       const gstPercentage = parseFloat(row.gstPercentage || row.igstRate || (parseFloat(row.cgstRate || 0) + parseFloat(row.sgstRate || 0))) || 0;
       const cessAmount = parseFloat(row.cessAmount) || 0;
       const otherCharges = parseFloat(row.otherCharges) || 0;
       const amount = qty * rate;

       let discountAmount = 0;
       if (discount > 0) {
         discountAmount = (amount * discount) / 100;
       } else if (discountQty > 0) {
         if (discountQty <= rate && discountQty > 0) {
           discountAmount = qty * discountQty;
         } else {
           discountAmount = discountQty;
         }
       }
       if (discountAmount > amount) discountAmount = amount;

       const taxableValue = Math.max(0, amount - discountAmount) + otherCharges;

       let cgstRate = 0, sgstRate = 0, igstRate = 0;
       let cgstAmount = 0, sgstAmount = 0, igstAmount = 0;

       if (gstPercentage > 0) {
         if (computedTaxType === "SGST_CGST") {
           cgstRate = sgstRate = gstPercentage / 2;
           cgstAmount = (taxableValue * cgstRate) / 100;
           sgstAmount = (taxableValue * sgstRate) / 100;
         } else {
           igstRate = gstPercentage;
           igstAmount = (taxableValue * igstRate) / 100;
         }
       }

       const total = parseFloat((taxableValue + cgstAmount + sgstAmount + igstAmount + cessAmount).toFixed(2));

       return {
         ...row,
         taxType: computedTaxType,
         gstPercentage,
         taxableValue: taxableValue.toFixed(2),
         cgstRate,
         sgstRate,
         igstRate,
         cgstAmount: cgstAmount.toFixed(2),
         sgstAmount: sgstAmount.toFixed(2),
         igstAmount: igstAmount.toFixed(2),
         total: total.toFixed(2),
       };
     })
   );
 }, [
   registrationData,
   localReceiverData?.stateCode,
   localReceiverData?.stateName,
   localReceiverData?.gst,
   consigneeDetails?.stateCode,
   consigneeDetails?.gstin,
   isSameDetails,
   placeOfSupply,
   states
 ]);



  useEffect(() => {
  if (!isSameDetails) {
    setConsigneeShippedToSame(false);
  }
}, [isSameDetails]);

  useEffect(() => {
    const gstNumber = localStorage.getItem("gstNumber");
    if (!gstNumber) return;

    const fetchProductsByGst = async () => {
      try {
        const token = localStorage.getItem("token");

const res = await axios.get(
  `${BASE_URL}/ProductUnitHsnMapping/GetProductDetailsBasedOnGST`,
  {
    params: { gstNumber },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
);
        if (res.data?.data) {
          setProductList(res.data.data);
        }
      } catch (err) {
        console.error("Error fetching products by GST:", err);
      }
    };

    fetchProductsByGst();
  }, []);


  // Table columns - IGST
  const [igstRates, setIgstRates] = useState([]);

  useEffect(() => {
    const fetchIGST = async () => {
      try {
        const token = localStorage.getItem("token");

const res = await axios.get(`${BASE_URL}/GSTPercentage/GetAllGsts`, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});
        if (res.data?.data) {
          setIgstRates(res.data.data);
        }
      } catch (err) {
        console.error("Failed to fetch IGST rates:", err);
      }
    };

    fetchIGST();
  }, []);

const handleConsigneeChange = (field, value) => {
const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  if (field === 'gstin') {
    value = value.toUpperCase();

    // Limit input to 15 characters max
   if (value.length > 15) {
      alert("GST Number should not exceed 15 characters");
      return;
    }
    // Validate only when 15 characters are entered
    if (value.length === 15 && !gstinRegex.test(value)) {
      alert('Invalid GST Number');
      setConsigneeDetails((prev) => ({
        ...prev,
        [field]: ''
      }));
      return;
    }
  }

  setConsigneeDetails((prev) => ({
    ...prev,
    [field]: value
  }));
};



const handleChange = (field, value) => {
  if (field === 'gst') {
    value = value.toUpperCase();

   if (value.length > 15) {
      alert("GST Number should not exceed 15 characters");
      return;
    }

    if (value.length === 15 && !gstinRegex.test(value)) {
      alert('Invalid GST Number');
      setLocalReceiverData((prev) => ({ ...prev, [field]: '' }));
      return;
    }
  }

  setLocalReceiverData((prev) => {
    const updated = { ...prev, [field]: value };
    if (field === 'gst' && value && value.length >= 2) {
      const gstCode = value.substring(0, 2);
      const matched = states.find(s => String(s.stateCode).padStart(2, '0') === String(gstCode).padStart(2, '0'));
      if (matched) {
        updated.stateCode = String(matched.stateCode).padStart(2, '0');
        updated.stateName = matched.stateName;
      }
    }
    return updated;
  });
};


  const handleSave = async () => {
  try {
    const payload = {
      name: localReceiverData.firstName,
      address: localReceiverData.address,
      gstin: localReceiverData.gst,
      state: localReceiverData.stateName,
      stateCode: Number(localReceiverData.stateCode),
      usergstin: localStorage.getItem("gstNumber")
    };


    const token = localStorage.getItem("token");

const res = await axios.post(
  `${BASE_URL}/ConsigneeMaster/Add`,
  payload,
  {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
);

    alert('Added To Master Data');

    toast.success('Added To Master Data');
    // setEditMode(false);

  } catch (err) {
    alert('Save to Consignee Master failed');
    console.error('Consignee save error:', err);
  }
};

  const handleSubmitInvoice = async () => {

  try {
    // Validations
    if (!invoiceNo.trim()) {
  alert("Please enter Invoice Number");
  return;
}

if (!invoiceDate) {
  alert("Please select Invoice Date");
  return;
}

// if (!dateOfSupply) {
//   alert("Please select Date Of Supply");
//   return;
// }

if (!placeOfSupply.trim()) {
  alert("Please enter Place Of Supply");
  return;
}

if (!localReceiverData.firstName.trim()) {
  alert("Please enter Receiver Name");
  return;
}

if (!localReceiverData.address.trim()) {
  alert("Please enter Receiver Address");
  return;
}

if (!localReceiverData.gst.trim()) {
  alert("Please enter Receiver GSTIN");
  return;
}

if (!localReceiverData.stateName.trim()) {
  alert("Please select Receiver State");
  return;
}

if (!localReceiverData.stateCode) {
  alert("Please enter Receiver State Code");
  return;
}
    // Product rows validation
    if (!Array.isArray(rows) || rows.length === 0) {
      return alert("At least one product must be added to the invoice.");
    }

    const invalidRow = rows.find((row, index) => {
      if (!row.productId || row.productId.trim() === "") {
        alert(`Product not selected in row ${index + 1}`);
        return true;
      }
      if (!row.qty || parseFloat(row.qty) <= 0) {
        alert(`Quantity is missing or invalid in row ${index + 1}`);
        return true;
      }
      if (!row.rate || parseFloat(row.rate) <= 0) {
        alert(`Rate is missing or invalid in row ${index + 1}`);
        return true;
      }
      return false;
    });

    if (invalidRow) return;




// Duplicate Invoice Validation
const token = localStorage.getItem("token");

const existingResponse = await axios.get(
  `${BASE_URL}/SalesInvoice/List`,
  {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
);

const existingInvoices = existingResponse.data?.data || [];

// Logged in user GST
const currentUserGST = localStorage
  .getItem("gstNumber")
  ?.toString()
  .trim()
  .toUpperCase();

// Final invoice number
const finalInvoiceNo = invoiceNo.trim().toUpperCase();

// Check duplicate only for current logged-in user
const isDuplicate = existingInvoices.some((item) => {

  const existingInvoiceNo = (
    item.InvoiceNumber || ""
  )
    .toString()
    .trim()
    .toUpperCase();

  const existingGST = (
    item.GSTNumber || ""
  )
    .toString()
    .trim()
    .toUpperCase();

  // Existing invoice financial year
  const existingDate = dayjs(item.InvoiceDate);

  const existingFYStart =
    existingDate.month() >= 3
      ? existingDate.year()
      : existingDate.year() - 1;

  const existingFYEnd = existingFYStart + 1;

  // Current selected invoice financial year
  const selectedDate = dayjs(invoiceDate);

  const currentFYStart =
    selectedDate.month() >= 3
      ? selectedDate.year()
      : selectedDate.year() - 1;

  const currentFYEnd = currentFYStart + 1;

  return (
    existingInvoiceNo === finalInvoiceNo &&
    existingGST === currentUserGST &&
    existingFYStart === currentFYStart &&
    existingFYEnd === currentFYEnd
  );
});

if (isDuplicate && !editModeSale) {
  alert("Invoice Number already exists");
  return;
}




    // Prepare products
    const products = rows.map((row) => {
      const qty = parseFloat(row.qty || 0);
      const rate = parseFloat(row.rate || 0);
      const grossAmount = qty * rate;
      const discPerc = parseFloat(row.discount || 0);
      const discAmtPerUnit = parseFloat(row.discountQty || 0);

      let calcDiscountAmt = 0;
      let discType = 0;
      let discPerUnit = 0;

      if (discPerc > 0) {
        discType = 0; // 0 = Percentage Discount
        calcDiscountAmt = (grossAmount * discPerc) / 100;
        discPerUnit = 0;
      } else if (discAmtPerUnit > 0) {
        discType = 1; // 1 = Rupee Discount
        if (discAmtPerUnit <= rate && discAmtPerUnit > 0) {
          calcDiscountAmt = qty * discAmtPerUnit;
          discPerUnit = discAmtPerUnit;
        } else {
          calcDiscountAmt = discAmtPerUnit;
          discPerUnit = qty > 0 ? (discAmtPerUnit / qty) : 0;
        }
      }

      if (calcDiscountAmt > grossAmount) calcDiscountAmt = grossAmount;

      const taxableVal = Math.max(0, grossAmount - calcDiscountAmt) + parseFloat(row.otherCharges || 0);
      const gstPct = parseFloat(row.gstPercentage || row.igstRate || (parseFloat(row.cgstRate || 0) + parseFloat(row.sgstRate || 0)) || 0);
      const isIntra = taxType === 'SGST_CGST';

      const cgstPct = isIntra ? (gstPct / 2) : 0;
      const sgstPct = isIntra ? (gstPct / 2) : 0;
      const igstPct = isIntra ? 0 : gstPct;

      const cgstAmt = isIntra ? parseFloat(((taxableVal * cgstPct) / 100).toFixed(2)) : 0;
      const sgstAmt = isIntra ? parseFloat(((taxableVal * sgstPct) / 100).toFixed(2)) : 0;
      const igstAmt = isIntra ? 0 : parseFloat(((taxableVal * igstPct) / 100).toFixed(2));

      const rowTotal = taxableVal + cgstAmt + sgstAmt + igstAmt + parseFloat(row.cessAmount || 0);

      return {
        ProductId: row.productId,
        HsnSacCode: row.hsn,
        Quantity: qty,
        UnitId: row.unit || '',
        Rate: rate,
        GSTRate: gstPct,
        TaxableValue: parseFloat(taxableVal.toFixed(2)),
        IGSTPercentage: igstPct,
        CGSTPercentage: cgstPct,
        SGSTPercentage: sgstPct,
        IGSTAmount: igstAmt,
        CGSTAmount: cgstAmt,
        SGSTAmount: sgstAmt,
        DiscountType: discType,
        DiscountPercentage: discPerc,
        DiscountAmountPerUnit: discPerUnit,
        DiscountAmount: parseFloat(calcDiscountAmt.toFixed(2)),
        OtherCharges: parseFloat(row.otherCharges || 0),
        Cess: parseFloat(row.cessAmount || 0),
        Total: parseFloat(rowTotal.toFixed(2)),
      };
    });
    
    const invoicePayload = {
  InvoiceType: invoiceType, // <-- Add this line
  ReverseCharge: reverseCharge || "No",
  InvoiceNumber: prefix ? `${prefix}/${invoiceNo}` : invoiceNo,
  //InvoiceDate: invoiceDate || new Date().toISOString(),
  InvoiceDate: invoiceDate
  ? new Date(
      new Date(invoiceDate).getFullYear(),
      new Date(invoiceDate).getMonth(),
      new Date(invoiceDate).getDate(),
      12,
      0,
      0
    )
  : new Date(),
  StateId: registrationData?.stateName || "",
  StateCode: registrationData?.stateCode || 0,
  ChallanNumber: challanNo || "",
  TransportationMode: transportationMode || "",
  VehicleNumber: vehicleNo || "",
  //DateOfSupply: dateOfSupply || new Date().toISOString(),
  DateOfSupply: dateOfSupply
  ? dayjs(dateOfSupply).toISOString()
  : null,
  PlaceOfSupply: placeOfSupply || "",
  TransporterId: transporterID || "",
  TransporterName: transporterName || "",
  LrBiltyNumber: lrNumber || "",
  //LrDate: lrDate || new Date().toISOString(),
  LrDate: lrDate
  ? dayjs(lrDate).toISOString()
  : null,
  GSTNumber: localStorage.getItem('gstNumber'),

  ReceiverDetails: {
    Name: localReceiverData.firstName || '',
    Address: localReceiverData.address || '',
    GSTNumber: localReceiverData.gst || '',
    StateId: localReceiverData.stateName || '',
    StateCode: parseInt(localReceiverData.stateCode || ''),
  },

  ConsigneeDetails: {
    Name: consigneeDetails.name || '',
    Address: consigneeDetails.address || '',
    GSTNumber: consigneeDetails.gstin || '',
    StateId: consigneeDetails.state || '',
    StateCode: parseInt(consigneeDetails.stateCode || ''),
  },

  Products: products,
};

console.log(invoicePayload);

    let response;

    if (editModeSale && invoiceId) {
      // In edit mode: append userId for amendment tracking
      invoicePayload.userId = localStorage.getItem('gstNumber');
      const token = localStorage.getItem("token");

response = await axios.put(
  `${BASE_URL}/SalesInvoice/Update/${invoiceId}`,
  invoicePayload,
  {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
);
    } else {
      const token = localStorage.getItem("token");

response = await axios.post(
  `${BASE_URL}/SalesInvoice/Add`,
  invoicePayload,
  {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
);
    }

    if (response.status === 200) {
      alert('Invoice saved successfully!');
      navigate('/GetSaleInvoices');
    }
  } catch (error) {
    console.error("❌ Error saving invoice:", error?.response?.data || error.message);
    alert('Failed to save invoice.');
  }
};

const handleProductChange = async (rowId, selectedProductName) => {
  const gstNumber = localStorage.getItem("gstNumber");

  const updatedRows = await Promise.all(
    rows.map(async (row) => {
      if (row.id === rowId) {
        // Clear old values first
        let updatedRow = {
          ...row,
          productId: selectedProductName,
          hsn: "",
          unit: "",
          gstPercentage: 0,
          igstRate: 0,
          taxableValue: "0.00",
          igstAmount: "0.00",
          sgstAmount: "0.00",
          cgstAmount: "0.00",
          total: "0.00",
        };

        try {
          const token = localStorage.getItem("token");

const res = await axios.get(
  `${BASE_URL}/ProductUnitHsnMapping/GetHsnUnitGstBasedOnProductName/${selectedProductName}`,
  {
    params: { gstNumber }, // Ensures gstNumber is included
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
);
          const mapping = res.data?.data?.[0];

          if (!mapping) {
            toast.warn(`No mapping found for ${selectedProductName}`);
            return updatedRow;
          }

          const qty = parseFloat(row.qty) || 0;
          const rate = parseFloat(row.rate) || 0;
          const gstPercentage = parseFloat(
            mapping?.GstPercentage?.PercentageValue ||
            mapping?.GstPercentageId?.PercentageValue ||
            mapping?.GstPercentage ||
            mapping?.GSTPercentage ||
            mapping?.GSTRate ||
            0
          );

          let taxableValue = qty * rate;
          let igstAmount = 0, sgstAmount = 0, cgstAmount = 0, total = 0;

          if (gstPercentage > 0) {
            if (taxType === "SGST_CGST") {
              sgstAmount = (taxableValue * (gstPercentage / 2)) / 100;
              cgstAmount = (taxableValue * (gstPercentage / 2)) / 100;
            } else if (taxType === "IGST") {
              igstAmount = (taxableValue * gstPercentage) / 100;
            }
            total = parseFloat((taxableValue + igstAmount + sgstAmount + cgstAmount).toFixed(2));
          }

          return {
            ...updatedRow,
            hsn: mapping?.HSNCode || "",
            unit: mapping?.Unit?.UnitName || "",
            gstPercentage: gstPercentage,
            igstRate: gstPercentage,
            taxableValue: taxableValue.toFixed(2),
            igstAmount: igstAmount.toFixed(2),
            sgstAmount: sgstAmount.toFixed(2),
            cgstAmount: cgstAmount.toFixed(2),
            total: total.toFixed(2),
            otherCharges: row.otherCharges || "0",
            cessAmount: row.cessAmount || "0",
            taxType,
          };
        } catch (error) {
          console.error("Error fetching mapping:", error);
          toast.error(`Failed to fetch mapping for ${selectedProductName}`);
          return updatedRow;
        }
      }
      return row;
    })
  );

  setRows(updatedRows);
};



  const addRow = () => {
    const newRow = {
      id: rows.length > 0 ? rows[rows.length - 1].id + 1 : 1,
      productId: "",
      hsnOptions: [],
      unitOptions: [],
      hsn: "",
      unit: "",
      qty: "",
      originalRate: "",
      rate: "",
      discount: "0",
      taxableValue: "",
      igstRate: "",
      igstAmount: "",
      total: "",
      cessAmount: "",
      otherCharges: "",
    };
    setRows([...rows, newRow]);
  };


  const removeRow = (id) => {
    if (rows.length === 1) return;
    setRows(rows.filter((row) => row.id !== id));
  };

  const handleInputChange = (rowId, field, value) => {
    setRows(rows.map(row => {
      if (row.id !== rowId) return row;

      let updatedRow = { ...row, [field]: value };

      const qty = parseFloat(updatedRow.qty) || 0;
      const rate = parseFloat(updatedRow.rate) || 0;
      const grossAmount = qty * rate;

      let discount = parseFloat(updatedRow.discount) || 0;
      let discountQty = parseFloat(updatedRow.discountQty) || 0;

      let discountAmount = 0;

      if (field === 'discount') {
        // User typed Disc (%) -> Calculate Rupee Discount Amount
        discountQty = 0;
        if (discount > 0 && grossAmount > 0) {
          discountAmount = (grossAmount * discount) / 100;
          updatedRow.discountQty = discountAmount.toFixed(2);
        } else {
          updatedRow.discountQty = "0";
        }
      } else if (field === 'discountQty') {
        // User typed Disc (Qty) -> Calculate Percentage (%)
        if (discountQty > 0) {
          if (discountQty <= rate && discountQty > 0) {
            discountAmount = qty * discountQty;
          } else {
            discountAmount = discountQty;
          }
          if (grossAmount > 0) {
            discount = (discountAmount / grossAmount) * 100;
            updatedRow.discount = discount.toFixed(2);
          }
        } else {
          updatedRow.discount = "0";
        }
      } else {
        // Changing Qty or Rate
        if (discount > 0 && grossAmount > 0) {
          discountAmount = (grossAmount * discount) / 100;
          updatedRow.discountQty = discountAmount.toFixed(2);
        } else if (discountQty > 0) {
          if (discountQty <= rate && discountQty > 0) {
            discountAmount = qty * discountQty;
          } else {
            discountAmount = discountQty;
          }
          if (grossAmount > 0) {
            updatedRow.discount = ((discountAmount / grossAmount) * 100).toFixed(2);
          }
        }
      }

      if (discountAmount > grossAmount) {
        discountAmount = grossAmount;
      }

      const gstPercentage = parseFloat(updatedRow.gstPercentage || updatedRow.igstRate || (parseFloat(updatedRow.cgstRate || 0) + parseFloat(updatedRow.sgstRate || 0))) || 0;
      const currentTaxType = updatedRow.taxType || taxType || "SGST_CGST";
      const cessAmount = parseFloat(updatedRow.cessAmount) || 0;
      const otherCharges = parseFloat(updatedRow.otherCharges) || 0;

      const taxableValue = Math.max(0, grossAmount - discountAmount) + otherCharges;

      let cgstRate = 0, sgstRate = 0, igstRate = 0;
      let cgstAmount = 0, sgstAmount = 0, igstAmount = 0;

      if (gstPercentage > 0) {
        if (currentTaxType === "SGST_CGST") {
          cgstRate = sgstRate = gstPercentage / 2;
          cgstAmount = (taxableValue * cgstRate) / 100;
          sgstAmount = (taxableValue * sgstRate) / 100;
        } else if (currentTaxType === "IGST") {
          igstRate = gstPercentage;
          igstAmount = (taxableValue * igstRate) / 100;
        }
      } else {
        cgstRate = 0;
        sgstRate = 0;
        igstRate = 0;
        cgstAmount = 0;
        sgstAmount = 0;
        igstAmount = 0;
      }

      const total = parseFloat((taxableValue + cgstAmount + sgstAmount + igstAmount + cessAmount).toFixed(2));

      return {
        ...updatedRow,
        discountAmount: discountAmount.toFixed(2),
        taxableValue: taxableValue.toFixed(2),
        cgstRate,
        sgstRate,
        igstRate,
        cgstAmount: cgstAmount.toFixed(2),
        sgstAmount: sgstAmount.toFixed(2),
        igstAmount: igstAmount.toFixed(2),
        total: total.toFixed(2),
      };
    }));
  };



const calculateTotals = () => {
  return calculateInvoiceSummary(rows, otherCharges, cessAmount);
};

   const convertNumberToWords = (amount) => {
  const numericValue = parseFloat(amount);
  if (isNaN(numericValue)) return "";

  const a = [
    '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten',
    'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
  ];
  const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

  const numToWords = (num) => {
    if ((num = num.toString()).length > 9) return 'Overflow';
    const n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return '';

    let str = '';
    str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + ' Crore ' : '';
    str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + ' Lakh ' : '';
    str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + ' Thousand ' : '';
    str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + ' Hundred ' : '';
    str += (n[5] != 0) ? ((str != '') ? 'and ' : '') +
      (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + ' ' : '';
    return str.trim();
  };

  const [rupees, paise] = numericValue.toFixed(2).split('.');
  let result = `${numToWords(rupees)} Rupees`;
  if (parseInt(paise) > 0) {
    result += ` and ${numToWords(paise)} Paise`;
  }
  return result;
};

  const filteredProductList = productList.filter((product) => {
  const percentage = product.GstPercentageId?.PercentageValue || 0;
  return invoiceType === "Tax Invoice" ? percentage >= 0 : percentage === 0;
});
// Function to reset all fields
const handleReset = () => {
  setRows([initialRowState]); // Reset product rows
  setGstSummary([]);
  setConsigneeShippedToSame(true);
  setReverseCharge('No');
  setInvoiceNo(''); // Auto-generate will run on next render if not in edit mode
  setPrefix(''); // Clear prefix as well
  setInvoiceDate(dayjs().startOf('day'));
  setChallanNo('');
  setTransportationMode('');
  setVehicleNo('');
  //setDateOfSupply(dayjs().startOf('day'));
  setDateOfSupply(null);
  setPlaceOfSupply(registrationData?.stateName || ''); // Reset to default based on registration
  setTransporterID('');
  setTransporterName('');
  setLrNumber('');
  //setLrDate(dayjs().startOf('day'));
  setLrDate(null);
  setOtherCharges(0);
  setCessAmount(0);
  setInvoiceType('Tax Invoice');
  setLocalReceiverData(initialLocalReceiverDataState);
  setConsigneeDetails(initialConsigneeDetailsState);
  setTaxType(''); // Reset tax type, it will be recalculated based on receiver state
  toast.info('All fields have been reset!');
};

const handleInvoiceTypeChange = (newType) => {
  setInvoiceType(newType);

  setRows([
    {
      id: 1,
      productId: "",
      hsnOptions: [],
      unitOptions: [],
      hsn: "",
      unit: "",
      qty: "",
      originalRate: "",
      rate: "",
      discount: "0",
      discountQty: "0",
      taxableValue: "",
      igstRate: "",
      igstAmount: "",
      cgstAmount: "",
      sgstAmount: "",
      cessAmount: "0",
      total: "",
      otherCharges: "0",
      gstPercentage: "",
      taxType: taxType,
    },
  ]);

  setChallanNo('');
  setTransportationMode('');
  setVehicleNo('');
  setPlaceOfSupply('');
  setTransporterID('');
  setTransporterName('');
  setLrNumber('');
  setOtherCharges(0);
  setCessAmount(0);

  setLocalReceiverData({
    firstName: '',
    address: '',
    gst: '',
    stateName: '',
    stateCode: ''
  });

  setConsigneeDetails({
    name: "",
    address: "",
    gstin: "",
    state: "",
    stateCode: "",
  });

  setGstSummary([]);
  setOpenDialog(false);
};

  return (
    <>
      <LayoutUserHeader />

      <Box sx={{ padding: 4 }}>
        <Typography variant="h5" gutterBottom align="center" fontWeight="bold">
          Add Sale Invoice
        </Typography>


        {/* Sale Invoice Header */}
   <Paper elevation={3} sx={{ p: 3, mb: 3 }}>


  <Grid container spacing={2} alignItems="center" justifyContent="center">
    {/* Logo */}
    <Grid item xs={12} sm={3} sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box
        sx={{
          width: 90,
          height: 90,
          borderRadius: '50%',
          border: '2px solid #ccc',
          backgroundColor: '#f5f5f5',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
        }}
      >
        {registrationData?.companyLogo ? (
          <img
            src={`${BASE_URL}/${registrationData.companyLogo.replace(/\\/g, '/')}`}
            alt="Company Logo"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              borderRadius: '50%',
            }}
          />
        ) : (
          <Typography variant="caption" color="textSecondary">
            No Image
          </Typography>
        )}
      </Box>
    </Grid>

    {/* Company Info */}
    <Grid item xs={12} sm={9}>
      {registrationData ? (
        <Box>
          {/* First Name centered */}
          <Typography
            variant="h6"
            sx={{ fontWeight: 'bold', textAlign: 'center', mb: 1 }}
          >
            {registrationData.firmName || 'N/A'}
          </Typography>

          {/* Remaining details left-aligned */}
          <Box sx={{ textAlign: 'left' }}>
            <Typography variant="body2" sx={{ mb: 0.5 }}>
            <strong>Reg. Address:</strong>  {registrationData.address || 'N/A'},
              {' '}
              {registrationData?.districtName || 'N/A'},
              {' '}
              {registrationData.stateName || 'N/A'} - {registrationData.pinCode || 'N/A'}
            </Typography>

            <Typography variant="body2" sx={{ mb: 0.5 }}>
              <strong>Mobile:</strong> {registrationData.mobileNumber || 'N/A'} &nbsp;&nbsp;
              <strong>Email:</strong> {registrationData.emailId || 'N/A'}&nbsp;&nbsp;

              <strong>GSTIN:</strong> {registrationData.gst || 'N/A'} &nbsp;&nbsp;
              <strong>PAN:</strong> {panNumber || 'N/A'}
            </Typography>
          </Box>
        </Box>
      ) : (
        <Typography variant="body2" color="textSecondary">
          Loading Registration Data...
        </Typography>
      )}
    </Grid>
  </Grid>
</Paper>



      <Paper sx={{ padding: 0, mb: 3, backgroundColor: '#fff', borderRadius: 2, boxShadow: 1 }}>
  <Typography
    variant="h6"
    sx={{
      mb: 3,
      textAlign: 'center',
      fontWeight: 'bold',
      color: '#333',
      letterSpacing: 1,backgroundColor: '#fafafa'
    }}
  >
    Tax Invoice
  </Typography>

  <Grid container spacing={2} justifyContent="center">
    {/* Column 1 */}
    <Grid
      item
      xs={12}
      md={4}
      sx={{
        border: '1px solid #ccc',
        p: 2,
        borderRadius: 1,
        backgroundColor: '#fffdfda6',
        width: '32%',
      }}
    >
      <FormControl fullWidth size="small" sx={{ mb: 2 }}>
        <InputLabel>Reverse Charge</InputLabel>
        <Select
          value={reverseCharge}
          label="Reverse Charge"
          onChange={(e) => setReverseCharge(e.target.value)}
        >
          <MenuItem value="Yes">Yes</MenuItem>
          <MenuItem value="No">No</MenuItem>
        </Select>
      </FormControl>

      {editModeSale ? (
  <TextField
  label="Invoice No"
  variant="outlined"
  size="small"
  fullWidth
  required
  sx={{ mb: 2 }}
  value={invoiceNo}
  onChange={(e) => setInvoiceNo(e.target.value)}
/>
) : (
  <TextField
  label="Invoice No"
  variant="outlined"
  size="small"
  fullWidth
  required
  sx={{ mb: 2 }}
  value={invoiceNo}
  onChange={(e) => setInvoiceNo(e.target.value)}
/>
)}

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label="Invoice Date"
          value={invoiceDate}
          onChange={(newValue) => setInvoiceDate(newValue)}
          format="DD-MM-YYYY"
          minDate={financialYearStart}
         // maxDate={financialYearEnd}
         maxDate={today}
          slotProps={{ textField: { size: 'small', fullWidth: true } }}
        />
      </LocalizationProvider>

      <Typography variant="body2" sx={{ mt: 2 }}>
        <strong>State:</strong> {registrationData?.stateName || 'N/A'}
      </Typography>
      <br/>
      <Typography variant="body2" sx={{ mt: 2 }}>
        {/* <strong>State Code:</strong> {registrationData?.stateCode || 'N/A'} */}
        <strong>State Code:</strong> {registrationData?.stateCode < 10 ? `0${registrationData.stateCode}` : registrationData?.stateCode || 'N/A'}
      </Typography>
    </Grid>

    {/* Column 2 */}
    <Grid
      item
      xs={12}
      md={4}
      sx={{
        border: '1px solid #ccc',
        p: 2,
        borderRadius: 1,
        backgroundColor: 'fffdfda6',
        width: '32%',
      }}
    >
      <TextField
        label="Challan No"
        variant="outlined"
        size="small"
        value={challanNo}
        onChange={(e) => setChallanNo(e.target.value)}
        fullWidth
        sx={{ mb: 2 }}
      />

      <TextField
        label="Transportation Mode"
        variant="outlined"
        size="small"
        value={transportationMode}
        onChange={(e) => setTransportationMode(e.target.value)}
        fullWidth
        sx={{ mb: 2 }}
      />

      <TextField
        label="Vehicle No."
        variant="outlined"
        size="small"
        value={vehicleNo}
        onChange={(e) => setVehicleNo(e.target.value.toUpperCase())}
        onBlur={handleBlur}
        fullWidth
        sx={{ mb: 2 }}
      />

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label="Date of Supply"
          value={dateOfSupply}
          onChange={(newValue) => setDateOfSupply(newValue)}
          format="DD-MM-YYYY"
          minDate={financialYearStart}
         // maxDate={financialYearEnd}
         maxDate={today}
          slotProps={{ textField: { size: 'small', fullWidth: true } }}
        />
      </LocalizationProvider>

      <TextField
        label="Place of Supply"
        variant="outlined"
        size="small"
        value={placeOfSupply}
        onChange={(e) => setPlaceOfSupply(e.target.value)}
        fullWidth
        sx={{ mt: 2 }}
        required
      />
    </Grid>

    {/* Column 3 */}
    <Grid
      item
      xs={12}
      md={4}
      sx={{
        border: '1px solid #ccc',
        p: 2,
        borderRadius: 1,
        backgroundColor: 'fffdfda6',
        width: '32%',
      }}
    >
      <TextField
        label="Transporter ID"
        variant="outlined"
        size="small"
        value={transporterID}
        onChange={(e) => setTransporterID(e.target.value)}
        fullWidth
        sx={{ mb: 2 }}
      />

      <TextField
        label="Transporter Name"
        variant="outlined"
        size="small"
        value={transporterName}
        onChange={(e) => setTransporterName(e.target.value)}
        fullWidth
        sx={{ mb: 2 }}
      />

      <TextField
        label="LR Number / Bilty Number"
        variant="outlined"
        size="small"
        value={lrNumber}
        onChange={(e) => setLrNumber(e.target.value)}
        fullWidth
        sx={{ mb: 2 }}
      />

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label="LR Date"
          value={lrDate}
          onChange={(newValue) => setLrDate(newValue)}
          format="DD-MM-YYYY"
          minDate={financialYearStart}
          //maxDate={financialYearEnd}
          maxDate={today}
          slotProps={{ textField: { size: 'small', fullWidth: true } }}
        />
      </LocalizationProvider>
    </Grid>
  </Grid>
</Paper>


        <Paper sx={{ padding: 0 }}>

  <Typography
    variant="h6"
    sx={{
      mb: 3,
      textAlign: 'center',
      fontWeight: 'bold',
      color: '#333',
      letterSpacing: 1,backgroundColor: '#fafafa'
    }}
  >
     Details of Receiver/Consignee
  </Typography>

          <Grid container spacing={2}>
               <Grid
      item
      xs={12}
      md={6}
      sx={{ border: '1px solid #ccc', p: 2, width: '48%', position: 'relative',backgroundColor: '#fffdfda6' }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
        Details of Receiver | Billed to:
      </Typography>
      <Divider sx={{ mb: 2 }} />
          <TextField
  label="Name"
  variant="outlined"
  fullWidth
  size="small"
  sx={{ mb: 1 }}
  value={localReceiverData.firstName}
  onChange={(e) =>
    setLocalReceiverData((prev) => ({
      ...prev,
      firstName: e.target.value
    }))
  }
/>

<TextField
  label="Address"
  variant="outlined"
  fullWidth
  multiline
  rows={3}
  size="small"
  sx={{ mb: 1 }}
  value={localReceiverData.address}
  onChange={(e) =>
    setLocalReceiverData((prev) => ({
      ...prev,
      address: e.target.value
    }))
  }
/>

<TextField
  label="GSTIN"
  variant="outlined"
  fullWidth
  size="small"
  sx={{ mb: 1 }}
  value={localReceiverData.gst}
  onChange={(e) => handleChange('gst', e.target.value)}
/>

<TextField
  select
  label="State"
  value={localReceiverData.stateCode}
onChange={(e) => {
  const selectedCode = e.target.value;

  const matchedState = states.find(
    (s) => s.stateCode === selectedCode
  );

  setLocalReceiverData((prev) => ({
    ...prev,
    stateCode: selectedCode,
    stateName: matchedState?.stateName || ''
  }));
if (!editModeSale) {
  setPlaceOfSupply(matchedState?.stateName || '');
}

  const gstPrefix = registrationData?.gst?.substring(0, 2);

  if (gstPrefix) {
    const newTaxType =
      gstPrefix === selectedCode
        ? 'SGST_CGST'
        : 'IGST';

    setTaxType(newTaxType);
  }
}}
  fullWidth
  size="small"
  sx={{ mb: 1 }}
>
  <MenuItem value="">
    <em>Select State</em>
  </MenuItem>
  {states.map((state) => (
    <MenuItem key={state.id} value={state.stateCode}>
      {state.stateName}
    </MenuItem>
  ))}
</TextField>

<TextField
  label="State Code"
  variant="outlined"
  fullWidth
  size="small"
  sx={{ mb: 2 }}
  value={
    localReceiverData.stateCode !== "" && !isNaN(localReceiverData.stateCode)
      ? String(localReceiverData.stateCode).padStart(2, "0")
      : ""
  }
  onChange={(e) => {
    const input = e.target.value;
    const numericValue = parseInt(input, 10);

    setLocalReceiverData((prev) => ({
      ...prev,
      stateCode: isNaN(numericValue) ? "" : numericValue
    }));
  }}
/>
          <Button
            variant="contained"
            startIcon={<SaveIcon />}
            size="small"
            onClick={handleSave}
          >
            Save To Master Data
          </Button>
          <Button
  variant="outlined"
  startIcon={<SaveIcon />}
  size="small"
  onClick={async () => {
    setOpenDialog(true);
    setLoadingConsignees(true);
    try {
      const gstNumber = localStorage.getItem("gstNumber");

      const response = await fetch(`${BASE_URL}/ConsigneeMaster/GetAll`);

      const data = await response.json();
      console.log(data);

      const filteredConsignees = data.data?.filter(
  (item) => item.usergstin === gstNumber
) || [];

console.log("Filtered Consignees:", filteredConsignees);

  setConsigneeList(filteredConsignees);

    } catch (error) {
      console.error('Error fetching consignee data:', error);
    } finally {
      setLoadingConsignees(false);
    }
  }}
  sx={{ ml: 2 }}
>
  Load From Master Data
</Button>

<Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="md" fullWidth>
  <DialogTitle>Select Consignee From Master Data</DialogTitle>
  <DialogContent dividers>
    {loadingConsignees ? (
      <CircularProgress />
    ) : consigneeList.length > 0 ? (
      <Grid container spacing={2}>
        {consigneeList.map((consignee, idx) => (
          <Grid item xs={12} sm={6} md={4} key={idx}>
            <Card variant="outlined">
              <CardActionArea
          onClick={() => {
  setLocalReceiverData({
    firstName: consignee.name || '',
    address: consignee.address || '',
    gst: consignee.gstin || '',
    stateName: consignee.state || '',
    stateCode: consignee.stateCode?.toString() || '',
  });
if (!editModeSale) {
  setPlaceOfSupply(consignee.state || '');
}

  setOpenDialog(false);

  // Update tax type also
  const gstPrefix = registrationData?.gst?.substring(0, 2);

  if (gstPrefix) {
    const newTaxType =
      gstPrefix === consignee.stateCode?.toString()
        ? 'SGST_CGST'
        : 'IGST';

    setTaxType(newTaxType);
  }
}}
              >
                <CardContent>
                  <Typography variant="subtitle2"><b>Name:</b> {consignee.name}</Typography>
                  <Typography variant="body2"><b>Address:</b> {consignee.address}</Typography>
                  <Typography variant="body2"><b>GSTIN:</b> {consignee.gstin}</Typography>
                  <Typography variant="body2"><b>State:</b> {consignee.state}</Typography>
                  <Typography variant="body2"><b>Code:</b> {consignee.stateCode}</Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    ) : (
      <Typography>No consignee records found.</Typography>
    )}
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setOpenDialog(false)} color="secondary">
      Close
    </Button>
  </DialogActions>
</Dialog>
    </Grid>

            <Grid item xs={12} md={6} sx={{ border: '1px solid #ccc', p: 2, width: '48%',backgroundColor: '#fffdfda6', }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                Details of Consignee | Shipped to:
              </Typography>
              <Divider sx={{ mb: 2 }} />
                    <TextField
                      label="Name"
                      value={consigneeDetails.name}
                      onChange={(e) => handleConsigneeChange('name', e.target.value)}
                      sx={{ mb: 2 }}
                      size="small"
                      fullWidth
                    />
                      <TextField
                      label="Address"
                      value={consigneeDetails.address}
                      onChange={(e) => handleConsigneeChange('address', e.target.value)}
                       fullWidth
  			              multiline
  			              rows={3}
  			              size="small"
  			              sx={{ mb: 1 }}
                    />
                    {/* <TextField
                      label="GSTIN"
                      value={consigneeDetails.gstin}
                      onChange={(e) => handleConsigneeChange('gstin', e.target.value)}
                      sx={{ mb: 2 }}
                      fullWidth
                      size="small"
                    /> */}
                     <TextField
  label="GSTIN"
  value={consigneeDetails.gstin}
  onChange={(e) => handleConsigneeChange('gstin', e.target.value)}
  size="small"
  sx={{ mb: 1 }}
  fullWidth
/>
                    <FormControl fullWidth sx={{ mb: 1 }}>

                      <TextField
  select
  label="State"
  value={consigneeDetails.stateCode}
  onChange={(e) => {
    const selectedCode = e.target.value;
    const matchedState = states.find(s => s.stateCode === selectedCode);

    setConsigneeDetails(prev => ({
      ...prev,
      stateCode: selectedCode,
      state: matchedState?.stateName || ''
    }));
  }}
  fullWidth
  size="small"
  sx={{ mb: 1 }}
>
  <MenuItem value=""><em>Select State</em></MenuItem>
  {states.map((state) => (
    <MenuItem key={state.id} value={state.stateCode}>
      {state.stateName}
    </MenuItem>
  ))}
</TextField>

                    </FormControl>
                    {/* <TextField
                      label="State Code"
                      value={consigneeDetails.stateCode}
                      onChange={(e) => handleConsigneeChange('stateCode', e.target.value)}
                      sx={{ mb: 2 }}
                      size="small"
                      fullWidth
                    /> */}
                  <TextField
  label="State Code"
  value={
    consigneeDetails.stateCode !== "" && !isNaN(consigneeDetails.stateCode)
      ? String(consigneeDetails.stateCode).padStart(2, "0")
      : ""
  }
  onChange={(e) => {
    const input = e.target.value;
    const numericValue = parseInt(input, 10);

    handleConsigneeChange('stateCode', isNaN(numericValue) ? "" : numericValue);
  }}
  sx={{ mb: 2 }}
  size="small"
  fullWidth
/>
<Button
  variant="outlined"
  startIcon={<SaveIcon />}
  size="small"
  onClick={async () => {
    setOpenDialogConsignee(true);
    setLoadingConsignees(true);
    try {
      const gstNumber = localStorage.getItem("gstNumber");
      const response = await fetch(`${BASE_URL}/ConsigneeMaster/GetAll`);
      const data = await response.json();

      const filteredConsignees = data.data?.filter(
        (item) => item.usergstin === gstNumber
      ) || [];

      setConsigneeList(filteredConsignees);

    } catch (error) {
      console.error('Error fetching consignee data:', error);
    } finally {
      setLoadingConsignees(false);
    }
  }}
  sx={{ ml: 2 }}
>
  Load From Master Data
</Button>
<Dialog
  open={openDialogConsignee}
  onClose={() => setOpenDialogConsignee(false)}
  maxWidth="md"
  fullWidth
>
  <DialogTitle>Select Consignee From Master Data</DialogTitle>
  <DialogContent dividers>
    {loadingConsignees ? (
      <CircularProgress />
    ) : consigneeList.length > 0 ? (
      <Grid container spacing={2}>
        {consigneeList.map((consignee, idx) => (
          <Grid item xs={12} sm={6} md={4} key={idx}>
            <Card variant="outlined">
              <CardActionArea
                onClick={() => {
                  setConsigneeDetails({
                    name: consignee.name || '',
                    address: consignee.address || '',
                    gstin: consignee.gstin || '',
                    state: consignee.state || '',
                    stateCode: consignee.stateCode?.toString() || '',
                  });
                  setOpenDialogConsignee(false);
                }}
              >
                <CardContent>
                  <Typography variant="subtitle2"><b>Name:</b> {consignee.name}</Typography>
                  <Typography variant="body2"><b>Address:</b> {consignee.address}</Typography>
                  <Typography variant="body2"><b>GSTIN:</b> {consignee.gstin}</Typography>
                  <Typography variant="body2"><b>State:</b> {consignee.state}</Typography>
                  <Typography variant="body2"><b>Code:</b> {consignee.stateCode}</Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    ) : (
      <Typography>No consignee records found.</Typography>
    )}
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setOpenDialogConsignee(false)} color="secondary">
      Close
    </Button>
  </DialogActions>
</Dialog>

                  <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>

                  </Box>

            </Grid>
          </Grid>
        </Paper>

        <Paper sx={{ padding: 0, mt: 3, mb: 3 }}>

  <Typography
    variant="h6"
    sx={{
      mb: 3,
      textAlign: 'center',
      fontWeight: 'bold',
      color: '#333',
      letterSpacing: 1,backgroundColor: '#fafafa'
    }}
  >
    Sale Invoice Details
  </Typography>
  <Box display="flex" justifyContent="center" alignItems="center" mb={2}>
  <FormControl component="fieldset">
    <RadioGroup
      row
      value={invoiceType}
      onChange={(e) => handleInvoiceTypeChange(e.target.value)}
    >
      <FormControlLabel
        value="Tax Invoice"
        control={<Radio color="primary" disabled={editModeSale} />}
        label="Tax Invoice"
      />
      <FormControlLabel
        value="Bill of Supply"
        control={<Radio color="primary" disabled={editModeSale} />}
        label="Bill of Supply"
      />
    </RadioGroup>
  </FormControl>
</Box>
          <TableContainer component={Paper} sx={{ border: "1px solid #ccc", mt: 2 }}>
  <Table size="small">
    <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
      <TableRow>
        <TableCell align="center">No</TableCell>
        <TableCell align="center">Product</TableCell>
        <TableCell align="center">HSN/SAC</TableCell>
        <TableCell align="center">GST %</TableCell>
        <TableCell align="center">Qty</TableCell>
        <TableCell align="center">Unit</TableCell>
        <TableCell align="center">Rate</TableCell>
        <TableCell align="center">Amount</TableCell>
        <TableCell align="center">Disc (%)</TableCell>
        <TableCell align="center">Disc (Qty)</TableCell>
        <TableCell align="center">Taxable Value</TableCell>
        <TableCell align="center">Other Charges</TableCell>
        <TableCell align="center">Cess</TableCell>
        <TableCell align="center">Total</TableCell>
        <TableCell align="center">Action</TableCell>
      </TableRow>
    </TableHead>

    <TableBody>
      {rows.map((row, index) => (
        <TableRow key={row.id}>
          <TableCell align="center">{index + 1}</TableCell>

          <TableCell align="center">
            <FormControl variant="standard" sx={{ minWidth: 100 }}>
              <Select
  value={row.productId}
  onChange={(e) => handleProductChange(row.id, e.target.value)}
  displayEmpty
>
  <MenuItem value="" disabled>Select</MenuItem>
  {filteredProductList.map((product) => (
    <MenuItem key={product.id} value={product.ProductName}>
      {product.ProductName}
    </MenuItem>
  ))}
</Select>
            </FormControl>
          </TableCell>
          <TableCell align="center">
            <Typography variant="body2">{row.hsn || "-"}</Typography>
          </TableCell>
          <TableCell align="center">
            <Typography variant="body2">
  {row.gstPercentage ? `${row.gstPercentage}%` : "-"}
</Typography>
          </TableCell>
          <TableCell align="center">
            <TextField
              variant="standard"
              type="number"
              value={row.qty}
              onChange={(e) => handleInputChange(row.id, "qty", e.target.value)}
              inputProps={{ min: 0 }}
              sx={{ width: 60 }}
            />
          </TableCell>

          <TableCell align="center">
            <Typography variant="body2">{row.unit || "-"}</Typography>
          </TableCell>

          <TableCell align="center">
            <TextField
              variant="standard"
              type="number"
              value={row.rate}
              onChange={(e) => handleInputChange(row.id, "rate", e.target.value)}
              // inputProps={{ min: 0, step: 0.1 }}
              sx={{ width: 60 }}
            />
          </TableCell>

          <TableCell align="center">
            {((parseFloat(row.qty) || 0) * (parseFloat(row.rate) || 0)).toFixed(2)}
          </TableCell>

          <TableCell align="center">
            <TextField
              variant="standard"
              type="number"
              value={row.discount}
              onChange={(e) => handleInputChange(row.id, "discount", e.target.value)}
              inputProps={{ min: 0, max: 100, step: 0.01 }}
              sx={{ width: 60 }}
            />
          </TableCell>

          <TableCell align="center">
            <TextField
              variant="standard"
              type="number"
              value={row.discountQty}
              onChange={(e) => handleInputChange(row.id, "discountQty", e.target.value)}
              sx={{ width: 60 }}
            />
          </TableCell>

          <TableCell align="center">{row.taxableValue}</TableCell>
          <TableCell align="center">
  <TextField
    variant="standard"
    type="number"
    size="small"
    value={row.otherCharges}
    onChange={(e) => handleInputChange(row.id, "otherCharges", e.target.value)}
    sx={{ width: 60 }}
  />
</TableCell>
<TableCell align="center">
  <TextField
    variant="standard"
    type="number"
    size="small"
    value={row.cess}
    onChange={(e) => handleInputChange(row.id, "cessAmount", e.target.value)}
    sx={{ width: 60 }}
  />
</TableCell>

          <TableCell align="center">{row.total}</TableCell>

          <TableCell align="center">
            <Box display="flex" justifyContent="center" gap={1}>
              <Button
                onClick={addRow}
                size="small"
                variant="outlined"
                color="success"
              >
                +
              </Button>
              {rows.length > 1 && (
                <Button
                  onClick={() => removeRow(row.id)}
                  size="small"
                  variant="outlined"
                  color="error"
                >
                  -
                </Button>
              )}
            </Box>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
</TableContainer>
        </Paper>
        <Paper sx={{ padding: 0, mb: 3 }}>
  <TableContainer component={Paper} className="mt-4">
    <Typography variant="h6" sx={{ m: 2, textAlign: 'center' }}>
      GST Summary
    </Typography>

    <Table size="small">
  <TableHead>
    <TableRow>
      <TableCell align="center">S.No</TableCell>
      <TableCell align="center">Tax %</TableCell>
      <TableCell align="center">Taxable Amount</TableCell>
      <TableCell align="center">CGST Amount</TableCell>
      <TableCell align="center">SGST Amount</TableCell>
      <TableCell align="center">IGST Amount</TableCell>
      <TableCell align="center">Total Tax Amount</TableCell>
    </TableRow>
  </TableHead>
  <TableBody>
    {rows.map((item, index) => {
      const gstRate =
        item.taxType === 'IGST'
          ? item.igstRate
          : (parseFloat(item.cgstRate || 0) + parseFloat(item.sgstRate || 0)).toFixed(2);

      const totalTax =
        item.taxType === 'IGST'
          ? parseFloat(item.igstAmount || 0)
          : parseFloat(item.cgstAmount || 0) + parseFloat(item.sgstAmount || 0);

      return (
        <TableRow key={index}>
          <TableCell align="center">{index + 1}</TableCell>
          <TableCell align="center">{gstRate}</TableCell>
          <TableCell align="center">{item.taxableValue}</TableCell>

          <TableCell align="center">
            {item.taxType === 'IGST' ? '-' : item.cgstAmount}
          </TableCell>
          <TableCell align="center">
            {item.taxType === 'IGST' ? '-' : item.sgstAmount}
          </TableCell>
          <TableCell align="center">
            {item.taxType === 'IGST' ? item.igstAmount : '-'}
          </TableCell>
          <TableCell align="center">{totalTax.toFixed(2)}</TableCell>
        </TableRow>
      );
    })}
  </TableBody>
</Table>
  </TableContainer>
</Paper>

        <Paper sx={{ padding: 0, mb: 3 }}>
            <Typography
    variant="h6"
    sx={{
      mb: 3,
      textAlign: 'center',
      fontWeight: 'bold',
      color: '#333',
      letterSpacing: 1,backgroundColor: '#fafafa'
    }}
  >
    Bank/Cash Details
  </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6} sx={{ border: '1px solid #ccc', p: 2, width: '48%',backgroundColor: '#fffdfda6' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                Bank Details
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <Typography variant="body2" sx={{ mb: 1 }}><strong>Account Holder Name:</strong> {registrationData?.accountHolderName || 'N/A'} </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}><strong>Bank Account Number:</strong> {registrationData?.accountNumber || 'N/A'} </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}><strong>Bank IFSC Code:</strong> {registrationData?.ifscCode || 'N/A'} </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}><strong>Bank Name:</strong> {registrationData?.bankName || 'N/A'} </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}><strong>Bank Branch Name:</strong> {registrationData?.bankBranch || 'N/A'} </Typography>
            </Grid>

            <Grid item xs={12} md={6} sx={{ border: '1px solid #ccc', p: 2, width: '48%',backgroundColor: '#fffdfda6' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                Cash Details
              </Typography>
              <Divider sx={{ mb: 2 }} />

              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Total Amount Before Tax:</strong> ₹ {calculateTotals().totalTaxableValue}
              </Typography>
              
              {parseFloat(calculateTotals().totalIgstAmount) > 0 && (
                <Typography variant="body2" sx={{ mb: 1 }}>
                  <strong>Tax (IGST Amount):</strong> ₹ {calculateTotals().totalIgstAmount}
                </Typography>
              )}

              {(parseFloat(calculateTotals().totalCgstAmount) > 0 || parseFloat(calculateTotals().totalSgstAmount) > 0) && (
                <>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>Tax (CGST Amount):</strong> ₹ {calculateTotals().totalCgstAmount}
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>Tax (SGST Amount):</strong> ₹ {calculateTotals().totalSgstAmount}
                  </Typography>
                </>
              )}

              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Amount With Tax (Grand Total):</strong> ₹ {calculateTotals().grandTotal}
              </Typography>

              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Amount in words:</strong> {convertNumberToWords(calculateTotals().grandTotal)} only
              </Typography>

            </Grid>

          </Grid>
        </Paper>



        {/* Conditions/Signature */}
        <Paper sx={{ padding: 0, mb: 3 }}>

  <Typography
    variant="h6"
    sx={{
      mb: 3,textAlign: 'center',
      textAlign: 'center',
      fontWeight: 'bold',
      color: '#333',
      letterSpacing: 1,backgroundColor: '#fafafa'
    }}
  >
     Conditions / Signature
  </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6} sx={{ border: '1px solid #ccc',  p: 2, width: '48%',backgroundColor: '#fffdfda6' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold',textAlign: 'center', mb: 1 ,}}>
                Terms And Conditions
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <Typography variant="body2" sx={{ mb: 1 }}>
                1. This is an electronically generated document.
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                2. All disputes are subject to {registrationData?.districtName} jurisdiction only.
              </Typography>
            </Grid>

            <Grid item xs={12} md={6} sx={{ border: '1px solid #ccc', p: 2, width: '48%',backgroundColor: '#fffdfda6' }}>

                <Typography
    variant="h6"
    sx={{
      mb: 3,
      textAlign: 'center',
      fontWeight: 'bold',
      color: '#333',
      letterSpacing: 1
    }}
  >
    Authorised Signatory
  </Typography>
              <Divider sx={{ mb: 2 }} />
              <Typography variant="body2" sx={{ mb: 1 }}>
                Certified that the particulars given above are true and correct.
              </Typography>
              <Typography variant="body2" sx={{ mb: 1, textAlign: 'center' }}>
                <strong>For, {registrationData?.firmName || 'N/A'} </strong>
              </Typography>

              <Box sx={{ height: 50, textAlign: "center" }} />
              <Typography variant="body2" sx={{ textAlign: "center" }} >
                <strong>Authorised Signatory</strong>
              </Typography>
            </Grid>
          </Grid>
        </Paper>



        <Box sx={{ textAlign: "center", mt: 3 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmitInvoice}
            sx={{ mr: 2 }} // Add some right margin for spacing
          >
            Submit
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleReset}
          >
            Reset
          </Button>
        </Box>


      </Box>

      <LayoutUserFooter />
    </>
  );
};

export default AddSaleInvoice;
